<template>
	<div id="set-configuration">
		<configurationTree :isReadOnly="false" />
	</div>
</template>

<script>
	/**
	 * @fileoverview set-configuration.vue is the second step of four in the Configuration Explorer. It displays
	 * the configuration tree for the reconfigured profile. It relies on vuex to map the state variables from the
	 * store files.
	 * 
	 * @components
	 * 		configurationTree - configuration tree for the reconfigured profile
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import configurationTree from "@/components/configuration-tree";
	import { mapState } from "vuex";

	export default {
		name: "setConfiguration",
		components: {
			configurationTree,
		},
		computed: {
			...mapState({
				allowSetConfigProgress: (state) => state.config.editingTreeDepth === 0,
				configurationValid: (state) => state.config.configurationValid,
				thresholdFormValid: (state) => state.config.thresholdFormValid,
			}),
		},
		methods: {
			/**
			 * Save profile configuration if the page is valid
			 */
			onSave() {
				return new Promise((resolve, reject) => {
					let verdict = false;

					if (this.configurationValid && this.thresholdFormValid) {
						verdict = true;
						// if the config seems valid, let's save it
						this.$store.dispatch("mapFactorConfigurationBack");
					} else {
						// if the config is invalid, tell the user
						const notification = {
							status: "error",
							message: "Fix missing or invalid settings before saving."
						};
						this.$store.dispatch("notifications/addNotification", notification);
					}

					if (verdict) {
						resolve();
					} else {
						reject("Failed validation");
					}
				});
			},
		},
	};
</script>

<!-- Styles defined in _setConfig.scss -->
